import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api } from "../lib/api";

const TABS = [
  { to: "/admin/inquiries", label: "Inquiries", testId: "admin-nav-inquiries" },
  { to: "/admin/documents", label: "Documents", testId: "admin-nav-documents" },
  { to: "/admin/chat-leads", label: "Chat Leads", testId: "admin-nav-chat-leads" },
];

const pillClass =
  "text-xs font-semibold border border-white/20 hover:border-offwhite text-offwhite/70 px-4 py-2.5 transition-colors duration-300";

export function AdminNav({ active, children }) {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } catch (err) {
      console.error("Logout failed:", err);
    }
    navigate("/admin/login");
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      {TABS.map((tab) =>
        tab.label === active ? (
          <span key={tab.to} className="text-xs font-semibold bg-forest text-offwhite px-4 py-2.5">
            {tab.label}
          </span>
        ) : (
          <Link key={tab.to} to={tab.to} data-testid={tab.testId} className={pillClass}>
            {tab.label}
          </Link>
        )
      )}
      {children}
      <button
        data-testid="admin-logout-button"
        onClick={logout}
        className={`inline-flex items-center gap-2 ${pillClass}`}
      >
        <LogOut className="w-3.5 h-3.5" />
        Sign Out
      </button>
    </div>
  );
}
